import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

Bugsnag.start({ apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY || process.env.SERVER_BUGSNAG_API_KEY, appVersion: process.env.NEXT_PUBLIC_APP_VERSION, plugins: [new BugsnagPluginReact(React)] });

export default Bugsnag;